export default __webpack_public_path__ + "static/media/logo.b39480d0.png";